export enum NotificationType {
  Error = 'error',
  Info = 'info',
  Success = 'success',
  Warn = 'warn',
}
